import type { ColumnsType } from 'antd/es/table';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { AssetOcppConfigurationKeyRow } from '../types';
import { displayConfigurationValue, displayReadonly } from '../utils';

export function useAssetOcppConfigurationColumns(): ColumnsType<AssetOcppConfigurationKeyRow> {
  const { t } = useTranslation(['assets', 'common']);

  return useMemo(
    () => [
      {
        title: t('detail.ocppConfiguration.columns.key', 'Key'),
        dataIndex: 'key',
        key: 'key',
        ellipsis: true,
        sorter: (a, b) => a.key.localeCompare(b.key),
      },
      {
        title: t('detail.ocppConfiguration.columns.value', 'Value'),
        dataIndex: 'value',
        key: 'value',
        ellipsis: true,
        render: (value: string | null) =>
          displayConfigurationValue(
            value,
            t('detail.ocppConfiguration.emptyValue', '—'),
          ),
      },
      {
        title: t('detail.ocppConfiguration.columns.readonly', 'Read-only'),
        dataIndex: 'readonly',
        key: 'readonly',
        width: 120,
        render: (value: boolean | null) =>
          displayReadonly(value, {
            yes: t('common:labels.yes', 'Yes'),
            no: t('common:labels.no', 'No'),
            empty: t('detail.ocppConfiguration.emptyValue', '—'),
          }),
      },
    ],
    [t],
  );
}
